{
  "it": {
    "installment_term": {
      "actions": {
        "addUnits": "Unità",
        "add_fraction": "Aggiungi frazione",
        "create": "Crea",
        "create_and_share": "Crea e condividi con il cliente",
        "create_price_term": "Nuova regola",
        "delete": "Elimina",
        "deleteMultiple": "Elimina...",
        "delete_cancel": "Annulla",
        "edit": "Modifica",
        "newInstallment": "Gruppo di rate",
        "only_create": "Crea soltanto",
        "publish_customer": "Pubblica per il cliente",
        "selectAll": "Seleziona tutte le {total} rate",
        "selectOne": "Seleziona una rata",
        "take": "Incassa"
      },
      "attributes": {
        "description": "Descrizione",
        "installments_count": "{count} rata | {count} rate",
        "name": "Titolo"
      },
      "labels": {
        "addAllSurcharges": "Tutte le migliorie attuali",
        "addAllUnitsPrices": "Tutti i prezzi delle unità",
        "amount": "Importo della rata",
        "balanceFractionTypes": "Tipi di frazione del saldo",
        "balanceTotal": "Saldo totale",
        "containsSurcharges": "Include migliorie",
        "create_decision_first": "Questa opzione sarà disponibile non appena avrà creato una decisione.",
        "deleteInstallmentTerm": "Elimina gruppo di rate",
        "description": "Descrizione",
        "documents": "Documenti",
        "duplicate_price_type": "Esiste già una frazione con questo tipo di prezzo.",
        "editInstallmentTerm": "Modifica gruppo di rate",
        "edit_description": "Modifica descrizione",
        "fixed": "Fisso",
        "fixedAmount": "Importo fisso di",
        "for": "per",
        "forEachUnit": "di ciascuna unità",
        "fraction_types": {
          "absolute": "Importo fisso",
          "relative": "Percentuale"
        },
        "goToAmounts": "Seleziona importi",
        "installments": "Finanze",
        "installmentsTitle": "Gruppo di rate",
        "installments_all_projects": "Finanze di tutti i progetti",
        "invalidAmount": "Importo non valido",
        "list": "Elenco",
        "name": "Gruppo di rate n. {count}",
        "noContainsSurcharges": "Non include migliorie",
        "noInstallmentsToPay": "Nessuna rata in sospeso",
        "noUnitsClick": "Ancora nessuna unità, faccia clic qui per aggiungere",
        "ofThe": "del",
        "price_types": {
          "custom_amount": "Altro",
          "price_value": "Valore totale",
          "price_value_construction": "Valore di costruzione",
          "price_value_construction_existing": "Costi della costruzione esistente",
          "price_value_fees": "Onorari di architettura/ingegneria",
          "price_value_land": "Valore del terreno",
          "surcharge": "Migliorie",
          "unit": "Prezzi delle unità"
        },
        "projectUnitsTotal": "{project_name} ha in totale {units_count_max} unità",
        "publish_now": "Pubblicare ora?",
        "rules": "Regole di pagamento",
        "rules_subtitle": "Definisca la percentuale o l'importo da incassare",
        "save_explainer": "Rendere questo gruppo di rate visibile ai clienti? Oppure salvarlo e pubblicarlo più tardi?",
        "selectUnits": "Seleziona unità",
        "selected": "{selected} rata selezionata. | {selected} rate selezionate.",
        "shortcuts": "Scorciatoie",
        "show_installment_terms_for": "Mostra le rate per",
        "step1Info": "Aggiunga una descrizione",
        "step2Subtitle": "Selezioni il progetto per includere subito tutte le unità.",
        "step2Title": "Quali unità sono collegate a questo gruppo di rate?",
        "surcharges": "Migliorie",
        "total": "Totale",
        "totalFixed": "Totale fisso",
        "totalPaid": "Totale pagato",
        "totalRequested": "Totale fatturato",
        "totalSelected": "Tutte le {total} rate sono selezionate.",
        "totalSurcharges": "Totale migliorie",
        "totalUnpaid": "Totale non pagato",
        "unitSelected": "Nessuna unità selezionata ancora | Un'unità selezionata | {count} unità selezionate",
        "units": "Unità"
      },
      "navigation": {
        "backToInstallmentTerms": "Torna alla panoramica dei gruppi di rate"
      },
      "placeholders": {
        "amount": "Selezioni un importo fisso o una percentuale del valore dell'unità o delle migliorie",
        "description": "Es. 10% - Dopo la gettata della soletta in cemento al primo piano...",
        "due_date": "Imposti una data entro cui la rata deve essere pagata",
        "employees": {
          "new": {
            "subtitle": "Aggiunga le rate e tenga traccia del loro stato",
            "title": "Crei una panoramica finanziaria"
          }
        },
        "installmentTermFractionNotice": "Gli importi delle rate non possono più essere modificati perché alcune rate sono già state consegnate al cliente",
        "name": "Es. Gruppo di rate n. 1, Gruppo di rate - Migliorie",
        "summary": "Riepilogo",
        "surcharge": "miglioria"
      },
      "toasts": {
        "bulk_create": "Rata creata con successo | Rate create con successo",
        "bulk_delete": "Rata eliminata con successo | Rate eliminate con successo",
        "bulk_update": "Rata aggiornata con successo | Rate aggiornate con successo",
        "delete": "Rata eliminata con successo",
        "update": "Rata aggiornata con successo"
      },
      "validation": {
        "fixedFractionLabel": "{price_type} è già stato combinato con {fraction_type} in un'altra rata esistente. Per mantenere la coerenza è consentito solo {fraction_type}.",
        "maxLengthName": "Il nome è troppo lungo",
        "needDescription": "Descrizione obbligatoria",
        "needInstallmentTermFraction": "È richiesto un prezzo del gruppo",
        "needName": "Nome obbligatorio",
        "needUniquePricesTypes": "Le regole non possono avere lo stesso tipo di prezzo all'interno di un gruppo di rate",
        "needValidTerm": "L'importo non può essere 0 e il tipo di prezzo deve esistere",
        "selectInstallmentTerm": "Selezioni almeno 1 rata",
        "selectUnit": "Selezioni almeno 1 unità"
      }
    }
  }
}
